import HomePage from './homePage.component';

export default HomePage;